import React, { useEffect, useRef, useState } from "react";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Components
import Layout from "../../../Layout/Layout";
import { InputField } from "../../../Components/formElements/InputField";
import { TextAreaField } from "../../../Components/formElements/TextAreaField";
import { useSelector } from "react-redux";
import ItemService from "../../../services/inventory_appCommonService";
import toast from "react-hot-toast";
import DraftModal from "../../../Components/CancleModal/DraftModal";
import { useNavigate } from "react-router-dom";
import WarehouseConstants from "../../../common/WarehouseConstants";
const StockDetails = () => {
  localStorage.setItem("menu", "Stock");
  localStorage.setItem("submenu", "stcok");
  const stockData = useSelector((state) => state?.inventory?.stock?.stockNr);
  const [showDraftModal, setShowDraftModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const historyGuardRef = useRef(false);
  const initialFormRef = useRef(null);
  const navigate = useNavigate();

  const handleUpdateClick = () => {
    setIsEditMode(true);

    if (!historyGuardRef.current) {
      window.history.pushState(
        { draftModalGuard: true },
        "",
        window.location.href,
      );
      historyGuardRef.current = true;
    }
  };

  const [isCardVisible, setCardVisible] = useState(true);
  const [formInputs, setFormInputs] = useState({
    slNo: "",
    stockCode: "",
    stockLongText: "",
    stockGroup: "",
    uOM: "",
    plant: "",
  });
  const status = formInputs?.headerStatus?.toLowerCase();

  const formInputsRef = useRef(formInputs);
  const hasFormChanges = () => {
    return JSON.stringify(formInputsRef.current) !== initialFormRef.current;
  };
  useEffect(() => {
    formInputsRef.current = formInputs;
  }, [formInputs]);
  // const handleCancelClick = () => {
  //   setIsEditMode(false);
  // };
  const handleCancelClick = () => {
    if (hasFormChanges()) {
      setShowDraftModal(true);
    } else {
      setIsEditMode(false);
      historyGuardRef.current = false;
    }
  };
  // const handleUpdateClick = () => {
  //   setIsEditMode(true);
  // };

  // useEffect(() => {
  //   const handlePopState = () => {
  //     if (isEditMode) {
  //       setShowDraftModal(true);
  //       window.history.pushState(
  //         { draftModalGuard: true },
  //         "",
  //         window.location.href,
  //       );
  //     }
  //   };

  //   window.addEventListener("popstate", handlePopState);

  //   return () => {
  //     window.removeEventListener("popstate", handlePopState);
  //   };
  // }, [isEditMode]);

  useEffect(() => {
    const handlePopState = () => {
      if (isEditMode && hasFormChanges()) {
        setShowDraftModal(true);
        window.history.pushState(
          { draftModalGuard: true },
          "",
          window.location.href,
        );
      } else {
        setIsEditMode(false);
        historyGuardRef.current = false;
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [isEditMode]); // ✅ formInputs removed from deps — listener no longer re-attaches on every keystroke
  const handleDiscardDraft = () => {
    setShowDraftModal(false);
    setIsEditMode(false);
    historyGuardRef.current = false;
    loadFirstLevelData();
  };

  const handleSaveAsDraft = async (payload) => {
    const toastId = toast.loading("Saving as draft...", {
      position: "top-right",
    });

    try {
      const draftPayload = {
        ...payload,
        headerStatus: "Draft",
        status: "Draft",
      };

      const response = await ItemService.updateStockDocument(draftPayload);

      toast.dismiss(toastId);

      if (response?.status === 200) {
        toast.success("Saved as draft successfully", {
          position: "top-right",
        });
        setShowDraftModal(false);
        setIsEditMode(false);
        initialFormRef.current = JSON.stringify(formInputs);
        historyGuardRef.current = false;
        loadFirstLevelData();
      } else {
        toast.error(response?.message || "Failed to save draft", {
          position: "top-right",
        });
      }

      return response;
    } catch (error) {
      console.error(error);
      toast.dismiss(toastId);
      toast.error("Something went wrong. Please try again.", {
        position: "top-right",
      });
      throw error;
    }
  };
  const handleSaveClick = async () => {
    const toastId = toast.loading("Saving...", {
      position: "top-right",
    });

    try {
      const payload = {
        ...formInputs,
        // contactDetails: getcustomerContactPerson,
        // certifications: getDocumentTypeData,
      };

      const response = await ItemService.updateStockDocument(payload);

      if (response?.status === 200) {
        toast.dismiss(toastId);
        toast.success("Warehouse updated successfully", {
          position: "top-right",
        });

        setIsEditMode(false);
        initialFormRef.current = JSON.stringify(formInputs);
        // loadIntialData1();
      } else {
        toast.dismiss(toastId);
        toast.error(response?.message || "Failed to update warehouse", {
          position: "top-right",
        });
      }
    } catch (error) {
      console.error(error);

      toast.dismiss(toastId);
      toast.error("Something went wrong. Please try again.", {
        position: "top-right",
      });
    }
  };

  const handleConvertToStock = async () => {
    let obj = {
      data: formInputs,
      type: "Save",
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };

    console.log("Payload:", obj);

    await ItemService.addStock(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "added successfully", {
          duration: 8000,
          position: "top-right",
        });
        navigate(WarehouseConstants.WH_STOCK_LIST);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      // setDisabled(false);
    });
  };
  const [validation, setValidation] = useState({
    slNo: "",
    stockCode: "",
    stockLongText: "",
    stockGroup: "",
    uOM: "",
    plant: "",
  });

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  const onInputChange = ({ target: { name, value } }) => {
    const errors = {};
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };

  const loadFirstLevelData = async (page) => {
    if (stockData) {
      let obj = {
        documentNumber: stockData,
      };
      await ItemService.getStockDatails(obj).then((item) => {
        if (item?.status === 200) {
          setFormInputs(item?.data[0]);
          initialFormRef.current = JSON.stringify(item?.data[0]);
        } else {
          setFormInputs([]);
          console.log(">> Error: Loading getCategory");
        }
      });
    }
  };

  useEffect(() => {
    loadFirstLevelData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Stock Details
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {stockData}
              </span>
              <span>
                {formInputs?.headerStatus === "New" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {formInputs?.statusHeader}
                  </span>
                ) : formInputs?.headerStatus === "Created" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {formInputs?.headerStatus}
                  </span>
                ) : formInputs?.headerStatus === "In Release" ? (
                  <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                    {formInputs?.headerStatus}
                  </span>
                ) : formInputs?.headerStatus === "Draft" ? (
                  <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                    {formInputs?.headerStatus}
                  </span>
                ) : formInputs?.headerStatus === "Acknowledged" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {formInputs?.headerStatus}
                  </span>
                ) : formInputs?.headerStatus === "Deleted" ? (
                  <span className="bg-table-status bg-table-delete-status headerStatusDetailedPage">
                    {formInputs?.headerStatus}
                  </span>
                ) : formInputs?.headerStatus === "Cancelled" ? (
                  <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                    {formInputs?.headerStatus}
                  </span>
                ) : (
                  formInputs?.headerStatus
                )}
              </span>
            </h2>
            <p className="subText">Stock Details</p>
            {/* <Row className="mb-2">
              <Col xs={12} className="d-flex justify-content-end gap-2">
                {!isEditMode ? (
                  <button
                    className="btnTable btn-update"
                    onClick={handleUpdateClick}
                    disabled={["deleted", "cancelled"].includes(
                      formInputs?.headerStatus?.toLowerCase(),
                    )}
                  >
                    <i className="bi bi-pencil-square"></i> Modify
                  </button>
                ) : (
                  <>
                    <button
                      className="btnTable btn-update"
                      onClick={handleSaveClick}
                    >
                      <i className="bi bi-save"></i> Save
                    </button>
                    <button
                      className="btn btn-secondary btn-update"
                      onClick={handleCancelClick}
                    >
                      <i className="bi bi-x-circle"></i> Cancel
                    </button>
                  </>
                )}
              </Col>
            </Row> */}
            <Row className="mb-2">
              <Col xs={12} className="d-flex justify-content-end gap-2">
                {!isEditMode ? (
                  <button
                    className="btnTable btn-update"
                    onClick={handleUpdateClick}
                    disabled={["deleted", "cancelled"].includes(status)}
                  >
                    <i className="bi bi-pencil-square"></i> Modify
                  </button>
                ) : (
                  <>
                    <button
                      className="btnTable btn-update"
                      onClick={
                        status === "draft"
                          ? handleConvertToStock
                          : handleSaveClick
                      }
                    >
                      <i
                        className={`bi ${status === "draft" ? "bi-arrow-repeat" : "bi-save"}`}
                      ></i>
                      {status === "draft" ? " Convert to Stock" : " Save"}
                    </button>

                    <button
                      className="btn btn-secondary btn-update"
                      onClick={handleCancelClick}
                    >
                      <i className="bi bi-x-circle"></i> Cancel
                    </button>
                  </>
                )}
              </Col>
            </Row>
            <hr />
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">SD</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">Stock Details</span>
                      <span className="subHeaderTitle">Stock Details</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Sl No."
                          label={
                            <>
                              <i className="bi bi-list-ol labelIcon"></i>
                              Sl No.
                            </>
                          }
                          name="slNo"
                          id="slNo"
                          extraLabel=""
                          value={formInputs.slNo || ""}
                          onChange={onInputChange}
                          error={validation.slNo || ""}
                          disabled={!isEditMode}
                          // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Stock Code"
                          label={
                            <>
                              <i className="bi bi-upc-scan labelIcon"></i>
                              Stock Code
                            </>
                          }
                          name="stockCode"
                          id="stockCode"
                          value={formInputs.stockCode || ""}
                          onChange={onInputChange}
                          error={validation.stockCode || ""}
                          disabled={!isEditMode}
                          // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Product Name"
                          label={
                            <>
                              <i className="bi bi-box-seam labelIcon"></i>
                              Product Name
                            </>
                          }
                          name="productName"
                          id="productName"
                          value={formInputs.productName || ""}
                          onChange={onInputChange}
                          error={validation.productName || ""}
                          disabled={!isEditMode}
                          // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Material Name"
                          label={
                            <>
                              <i className="bi bi-box labelIcon"></i>
                              Material Name
                            </>
                          }
                          name="materialName"
                          id="materialName"
                          value={formInputs.materialName || ""}
                          onChange={onInputChange}
                          error={validation.materialName || ""}
                          disabled={!isEditMode}
                          // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Quantity"
                          label={
                            <>
                              <i className="bi bi-123 labelIcon"></i>
                              Quantity
                            </>
                          }
                          name="quantity"
                          id="quantity"
                          value={formInputs.quantity || ""}
                          onChange={onInputChange}
                          error={validation.quantity || ""}
                          disabled={!isEditMode}
                          // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="UOM"
                          label={
                            <>
                              <i className="bi bi-rulers labelIcon"></i>
                              UOM
                            </>
                          }
                          name="uOM"
                          id="uOM"
                          extraLabel=""
                          value={formInputs.uOM || ""}
                          onChange={onInputChange}
                          error={validation.uOM || ""}
                          disabled={!isEditMode}
                          // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Batch Number"
                          label={
                            <>
                              <i className="bi bi-hash labelIcon"></i>
                              Batch Number
                            </>
                          }
                          name="batchNumber"
                          id="batchNumber"
                          value={formInputs.batchNumber || ""}
                          onChange={onInputChange}
                          error={validation.batchNumber || ""}
                          disabled={!isEditMode}
                          // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Supplier Namer"
                          label={
                            <>
                              <i className="bi bi-person-vcard labelIcon"></i>
                              Supplier Name
                            </>
                          }
                          name="supplierName"
                          id="supplierName"
                          value={formInputs.supplierName || ""}
                          onChange={onInputChange}
                          error={validation.supplierName || ""}
                          disabled={!isEditMode}
                          // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Storage Location"
                          label={
                            <>
                              <i className="bi bi-geo-alt labelIcon"></i>
                              Storage Location
                            </>
                          }
                          name="storageLocation"
                          id="storageLocation"
                          value={formInputs.storageLocation || ""}
                          onChange={onInputChange}
                          error={validation.storageLocation || ""}
                          // required={true}
                          disabled={!isEditMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Stock Group"
                          label={
                            <>
                              <i className="bi bi-collection labelIcon"></i>
                              Stock Group
                            </>
                          }
                          name="stockGroup"
                          id="stockGroup"
                          extraLabel=""
                          value={formInputs.stockGroup || ""}
                          onChange={onInputChange}
                          error={validation.stockGroup || ""}
                          disabled={!isEditMode}
                          // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          // label="Stock Description"
                          label={
                            <>
                              <i className="bi bi-card-text labelIcon"></i>
                              Stock Description
                            </>
                          }
                          type="text"
                          name="stockDesc"
                          id="stockDesc"
                          value={formInputs.stockDesc || ""}
                          onChange={onInputChange}
                          error={validation.stockDesc || ""}
                          disabled={!isEditMode}
                          // required={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <DraftModal
        show={showDraftModal}
        onHide={() => setShowDraftModal(false)}
        type="stock"
        title="Save as Draft"
        formData={formInputs}
        onConfirm={handleSaveAsDraft}
        onDiscard={handleDiscardDraft}
      />
    </main>
  );
};

export default StockDetails;
